import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { AppCard, AppModal, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalConstructionNormalAspectsCard(
  props
) {

  const { values, name, motive, subphase } = props;
  const isAdmin = useSelector((state) => state.auth?.user?.isAdmin);
  const [showModal, setShowModal] = useState(false);
  const [valuationText] = useState([
    <Translator file="module-comsaEnvironmental" name="no.applicable" />,
    <Translator file="module-comsaEnvironmental" name="not-significant" />,
    <Translator file="module-comsaEnvironmental" name="significant" />,
  ]);

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="reason" />:
          </div>
          <div>
            <b>{motive}</b>
            {isAdmin && (
              <AppRemixIcon
                icon="information"
                onClick={() => setShowModal(true)}
                filled
                className="pointer ml-1"
              />
            )}
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="sub-phase" />:
          </div>
          <div>
            <b>{subphase}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator
              file="module-comsaEnvironmental"
              name="risk.assessment"
            />
            :
          </div>
          <div
            className={
              values?.[name]?.riskEvaluation === 2
                ? 'text-danger'
                : values?.[name]?.riskEvaluation === 1
                ? 'text-warning'
                : 'text-success'
            }
          >
            <b>{valuationText[values?.[name]?.riskEvaluation] || ''}</b>
          </div>
        </div>
      </div>
      <AppModal
        show={showModal}
        title={ReactDOMServer.renderToString(motive)}
        onClose={() => setShowModal(false)}
      >
        <table>
          <tbody>
            <tr>
              <td>
                <b>Nombre técnico:</b>
              </td>
              <td>{name}</td>
            </tr>
            <tr>
              <td>
                <b>Aplicabilidad:</b>
              </td>
              <td>{values?.[name]?.applicability}</td>
            </tr>
            <tr>
              <td>
                <b>Puntuación:</b>
              </td>
              <td>{values?.[name]?.score}</td>
            </tr>
            <tr>
              <td>
                <b>Sensibilidad:</b>
              </td>
              <td>{values?.[name]?.sensibility}</td>
            </tr>
            <tr>
              <td>
                <b>Evaluación:</b>
              </td>
              <td>{values?.[name]?.riskEvaluation}</td>
            </tr>
          </tbody>
        </table>
        <div className="alert alert-info mt-2">
          <i>
            <b>Evaluación:</b> 0 No aplicable, 1 No significativo, 2
            Significativo
          </i>
        </div>
      </AppModal>
    </Container>
  );
}

const Container = styled(AppCard)`
  .info-block {
    display: flex;
    text-align: center;
    .line {
      color: ${colors.primaryLight};
    }
  }
  .info-block {
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;
